import { useTranslation } from "react-i18next";
import { SuccessIcon } from "@/shared/ui/icons/success-icon";
import Button from "@/shared/ui/components/button";
import Modal from "@/shared/ui/components/modal";
import MoneyAmount from "@/shared/ui/components/money-amount";

export default function ApplePayModal({
  isOpen,
  onClose,
  onPayClick,
  downPaymentAmount,
  currency,
}: {
  isOpen: boolean;
  onClose: () => void;
  onPayClick: () => void | Promise<void>;
  downPaymentAmount?: number;
  currency?: string;
}) {
  const { t, i18n } = useTranslation();

  if (!isOpen) return null;

  return (
    <Modal
      onClose={onClose}
      showCloseButton
      stickyFooter={
        <div className="flex justify-center w-full px-4 pb-4">
          <div className="w-[335px]">
            <Button
              size="large"
              onClick={onPayClick}
              variant="primary"
              className="w-full !py-3 !px-3"
            >
              <span className="flex items-center justify-center gap-2">
                {t("apple_pay_modal.pay")}
                <MoneyAmount
                  amount={downPaymentAmount ?? 0}
                  currency={currency}
                  language={i18n.language}
                />
              </span>
            </Button>
          </div>
        </div>
      }
    >
      <div className="flex flex-col items-center w-[375px] mx-auto py-5 px-5 pb-3">
        {/* Success Icon */}
        <div className="mt-8 mb-6">
          <SuccessIcon width={50} height={50} />
        </div>

        {/* Title */}
        <h2
          className="text-center mb-4 text-[#16181D] text-xl font-bold leading-6 tracking-[-0.3px]"
          style={{ fontFeatureSettings: "'liga' off" }}
        >
          {t("apple_pay_modal.verification_complete")}
        </h2>

        {/* Subtitle */}
        <p className="text-center px-4 text-[#16181D] text-sm font-medium leading-6 tracking-[-0.21px]">
          {t("apple_pay_modal.subtitle")}
        </p>
      </div>
    </Modal>
  );
}
